import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState({
    submitted: false,
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    console.log('Form submitted:', formData);
    
    // Simulate form submission
    setFormStatus({
      submitted: true,
      message: 'Thank you for your message. We will get back to you soon!'
    });

    // Reset form after 3 seconds
    setTimeout(() => {
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      setFormStatus({
        submitted: false,
        message: ''
      });
    }, 3000);
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        
        {/* Header Section */}
        <section className="contact-header">
          <h1 className="contact-title">Contact Us</h1>
          <p className="contact-subtitle">
            Get in touch with the Biomaterials & Tissue Engineering Laboratory
          </p>
        </section>

        {/* Main Contact Content */}
        <div className="contact-content">
          
          {/* Contact Information Card */}
          <div className="contact-info-section">
            <div className="info-card primary-card">
              <div className="card-header">
                <div className="profile-section">
                  <div className="profile-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div className="profile-details">
                    <h2 className="professor-name">Prof. Biman B. Mandal</h2>
                    <p className="professor-title">Professor</p>
                    <div className="professor-badges">
                      <span className="badge">NASI Fellow</span>
                      <span className="badge">SwarnaJayanti Fellow</span>
                      <span className="badge">National Bioscience Awardee</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body">
                <div className="info-group">
                  <h3>Academic Affiliations</h3>
                  <ul className="affiliations-list">
                    <li>Department of Biosciences and Bioengineering</li>
                    <li>Associated Faculty: Center for Nanotechnology</li>
                    <li>Associated Faculty: School of Health Sciences and Technology</li>
                    <li>Adjunct Professor: Faculty of Pharmaceutical Sciences, Chulalongkorn University, Bangkok 10330, Thailand</li>
                  </ul>
                </div>

                <div className="info-grid">
                  <div className="info-item">
                    <div className="info-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" strokeWidth="2"/>
                        <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" strokeWidth="2"/>
                      </svg>
                    </div>
                    <div className="info-content">
                      <h4>Office Location</h4>
                      <p>N-Block, Room no - N-107</p>
                      <p>Indian Institute of Technology Guwahati</p>
                      <p>Guwahati - 781 039, Assam, INDIA</p>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" strokeWidth="2"/>
                      </svg>
                    </div>
                    <div className="info-content">
                      <h4>Phone</h4>
                      <p>+91 361 258 2225 (Office)</p>
                      <h4 className="mt-2">Fax</h4>
                      <p>+91 361 258 2249 (Office)</p>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" strokeWidth="2"/>
                      </svg>
                    </div>
                    <div className="info-content">
                      <h4>Email</h4>
                      <a href="mailto:biman.mandal@iitg.ac.in" className="email-link">
                        biman.mandal@iitg.ac.in
                      </a>
                      <a href="mailto:mandal.biman@gmail.com" className="email-link">
                        mandal.biman@gmail.com
                      </a>
                    </div>
                  </div>
                </div>

                <div className="quick-links">
                  <a href="https://www.iitg.ac.in" target="_blank" rel="noopener noreferrer" className="quick-link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" strokeWidth="2"/>
                    </svg>
                    Visit IIT Guwahati
                  </a>
                  <a href="https://www.iitg.ac.in/biotech/" target="_blank" rel="noopener noreferrer" className="quick-link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" strokeWidth="2"/>
                    </svg>
                    Department Website
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form Section */}
          <div className="contact-form-section">
            <div className="form-card">
              <h3 className="form-title">Send us a Message</h3>
              <p className="form-description">
                Have a question or interested in our research? We'd love to hear from you.
              </p>

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      placeholder="Your Name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      placeholder="your.email@example.com"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    required
                    placeholder="What is this regarding?"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows="6"
                    placeholder="Your message here..."
                  />
                </div>

                {formStatus.submitted && (
                  <div className="form-success">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" strokeWidth="2"/>
                    </svg>
                    <span>{formStatus.message}</span>
                  </div>
                )}

                <button type="submit" className="submit-btn" disabled={formStatus.submitted}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" strokeWidth="2"/>
                  </svg>
                  {formStatus.submitted ? 'Message Sent!' : 'Send Message'}
                </button>
              </form>
            </div>

            {/* Map Section */}
            <div className="map-card">
              <h3 className="map-title">Find Us</h3>
              <div className="map-container">
                <iframe
                  title="IIT Guwahati Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3580.1256062664697!2d91.68836831502!3d26.1924!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375a5ac1e7cc93d5%3A0x4c4c0c3d4c4c4c4c!2sIndian%20Institute%20of%20Technology%20Guwahati!5e0!3m2!1sen!2sin!4v1234567890"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <div className="directions-link">
                <a 
                  href="https://www.iitg.ac.in/campusmap/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="get-directions"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" strokeWidth="2"/>
                  </svg>
                  Get Directions
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Information */}
        <section className="additional-info">
          <div className="info-boxes">
            <div className="info-box">
              <div className="box-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" strokeWidth="2"/>
                </svg>
              </div>
              <h4>Office Hours</h4>
              <p>Monday - Friday</p>
              <p className="highlight">9:00 AM - 5:00 PM IST</p>
            </div>

            <div className="info-box">
              <div className="box-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" strokeWidth="2"/>
                </svg>
              </div>
              <h4>Collaboration</h4>
              <p>Open for Research Collaborations</p>
              <p className="highlight">& Industrial Partnerships</p>
            </div>

            <div className="info-box">
              <div className="box-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" strokeWidth="2"/>
                </svg>
              </div>
              <h4>Research Opportunities</h4>
              <p>PhD, Post-doc Positions</p>
              <p className="highlight">& Project Internships</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;